module.exports = __webpack_public_path__ + "static/media/news-bg-en.c60b5268.jpg";